import axios, { AxiosResponse } from 'axios';
import { ApiRoutes } from '../constants/ApiRoutes';
import { Auth } from 'aws-amplify';
import { storageKeys } from '../constants/storageKeys';
import { appRoutes } from '../constants/appRoutes';

export const getHeaders = async () => {
  let headers, token;
  await Auth.currentSession()
    .then((response) => {
      token = response.idToken.jwtToken;
      sessionStorage.setItem(storageKeys.SESSION_TOKEN, response.idToken.jwtToken)
    })
    .catch((error) => {
      console.log(error);
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = appRoutes.LOGIN;
    });

  // eslint-disable-next-line prefer-const
  headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token ?? ''}`,
  };
  return headers;
};

const axiosInstance = axios.create({
  baseURL: ApiRoutes.BASE_URL,
  timeout: 40000,
});

axiosInstance.interceptors.request.use(async function (config) {
  config.headers = await getHeaders();
  return config;
});

axiosInstance.interceptors.response.use(
  (response): AxiosResponse => {
    return {
      data: response.data,
      statusText: response.statusText,
      status: response.status,
      headers: response.headers,
      config: response.config,
    };
  },
  (error) => {
    const { response } = error;
    switch (response.status) {
      case 401:
        localStorage.clear();
        return (window.location.href = appRoutes.LOGIN);
      default:
        break;
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
